export * from './ProfessioniDTO';
export * from './LandingDTO';
export * from './IntRes';
export * from './ProvinceDTO';
export * from './ResponseVM';
export * from './ConfigVM';
export * from './IpInfoVM';
export * from './QueryStringVM';